export const environment = {
  production: false,
  api: {
    signupUrl: "https://signupapi-staging.aptemassess.co.uk"
  },
};
